import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import logger from 'packages/logger';
import * as loginAnalytics from 'app/ui/layout/login-signup-analytics';
import { Analytics } from 'packages';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
import { loadScript } from 'tradera-utils/script';
import GoogleIcon from '@tradera/blueprint/theme/icons-colored/google.svg?jsx';
import LoadingIcon from '@tradera/blueprint/theme/icons2/loading.svg?jsx';

const GoogleLoginButton = props => {
    const {
        googleAppId,
        className,
        compact,
        disabled,
        isModal,
        onError,
        tabIndex
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    const getGoogleAuth2 = async () => {
        const gapi = window.gapi;
        let promiseResolve;
        let promise = new Promise(resolve => (promiseResolve = resolve));

        gapi.load('auth2', async () => {
            const auth2 = await gapi.auth2.init({
                client_id: googleAppId,
                fetch_basic_profile: true
            });
            promiseResolve(auth2);
        });
        return promise;
    };

    const performLogin = async () => {
        await loadScript(`https://apis.google.com/js/platform.js`, {
            timeout: 5000
        });
        const auth2 = await getGoogleAuth2();

        // signIn
        const googleUser = await auth2.signIn();
        const id_token = googleUser.getAuthResponse().id_token;

        try {
            const verifyResponse = await axios.post(
                '/login/google/verify' + window.location.search,
                {
                    accessToken: id_token,
                    UserId: 'NOT_USED'
                }
            );
            console.log('verifyResponse', verifyResponse);

            if (isModal) {
                Analytics.trackEvent({
                    category: 'Top navigation',
                    action: 'Login menu',
                    label: 'Button - Google login'
                });
            }
            loginAnalytics.flow.set(loginAnalytics.FLOW.LOGIN);
            loginAnalytics.method.set(loginAnalytics.METHOD.GOOGLE);
            loginAnalytics.trackEvent('user-login-submit');

            window.top.location = verifyResponse.data.returnUrl;
        } catch (error) {
            const message =
                error?.response?.data?.error || error?.message || error?.error;
            switch (message) {
                case 'popup_closed_by_user':
                    break;
                case 'MemberAuth_IncorrectUserOrPassword':
                    window.top.location = toLocalizedUrl(
                        '/login?connect=Google'
                    );
                    break;
                default:
                    onError(error);
                    logger(message);
                    break;
            }
        }
    };

    const onClick = async () => {
        if (disabled) {
            return;
        }

        setIsLoading(true);
        onError(null);
        try {
            await performLogin();
        } catch (error) {
            onError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            className={`btn btn-outline-dark btn-fluid ${
                compact ? '' : 'btn--icon-fixed'
            }
                    ${disabled ? ' disabled' : ''} ${className}`}
            onClick={onClick}
            disabled={disabled}
            tabIndex={tabIndex}>
            {isLoading ? (
                <LoadingIcon
                    className={`icon ${compact ? '' : 'icon-before'} icon-spin`}
                />
            ) : (
                <GoogleIcon
                    className={`icon ${compact ? '' : 'icon-before mr-2'}`}
                />
            )}
            {!compact && t('login_withProvider', { provider: 'Google' })}
        </button>
    );
};

GoogleLoginButton.propTypes = {
    className: PropTypes.string,
    googleAppId: PropTypes.string,
    isModal: PropTypes.bool,
    tabIndex: PropTypes.number
};

GoogleLoginButton.defaultProps = {
    className: '',
    tabIndex: 0
};

export default GoogleLoginButton;
